import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { getType } from 'typesafe-actions';
import { useHistory, useLocation } from 'react-router-dom';
import {
  resetPasswordInit,
  ResetPasswordDto,
  resetPasswordValidationSchema,
} from './resetPassword.dtos';
import { resetPasswordActions } from './resetPassword.actions';

import Logo from '../../../common/components/Logo';
import { Button, Grid, Typography, TextField } from '@material-ui/core';

import { CenterAlign } from '../../../common/components/layout';
import { PasswordTextField } from '../../../common/components/fields';
import {
  ResponsiveCard,
  ResponsiveCardActions,
  ResponsiveCardContent,
} from '../../../common/components/cards';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPassword: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  let query = useQuery();
  const userId = query.get('UserId');
  const code = query.get('code');

  const [initialDto, setInitialDto] = useState(resetPasswordInit);

  const onCancel = () => history.push('/login');

  useEffect(() => {
    let dto = JSON.parse(JSON.stringify(initialDto)) as ResetPasswordDto;
    dto.userId = userId ?? '';
    dto.token = code ?? '';
    setInitialDto(dto);
  }, []);

  return (
    <CenterAlign>
      <ResponsiveCard>
        <Logo />
        <Formik
          initialValues={initialDto}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={resetPasswordValidationSchema}
          onSubmit={(values, { setSubmitting }) => {
            values.token = initialDto.token;
            values.userId = userId!;
            setTimeout(() => {
              setTimeout(() => {
                setSubmitting(false);
              }, 700);

              values.token = initialDto.token;
              dispatch({
                type: getType(resetPasswordActions.request),
                payload: values,
              });
            }, 400);
          }}
        >
          {(props) => {
            const {
              values,
              errors,
              isSubmitting,
              handleChange,
              handleSubmit,
            } = props;
            return (
              <form
                onSubmit={(e) => {
                  handleSubmit();
                  e.preventDefault();
                }}
              >
                <ResponsiveCardContent>
                  <Typography variant='h6'>Reset Password</Typography>
                  <Typography variant='caption'>
                    Password must be 12 characters or longer with at least 1
                    uppercase letter, 1 lowercase letter, 1 number and 1 special
                    character.
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label='Username'
                        fullWidth
                        name='username'
                        value={values.username}
                        onChange={handleChange}
                        required
                        error={Boolean(errors.username)}
                        helperText={errors.username}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <PasswordTextField
                        label='Password'
                        fullWidth
                        name='password'
                        value={values.password}
                        onChange={handleChange}
                        required
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <PasswordTextField
                        label='Confirm password'
                        fullWidth
                        name='confirmPassword'
                        value={values.confirmPassword}
                        onChange={handleChange}
                        required
                        error={Boolean(errors.confirmPassword)}
                        helperText={errors.confirmPassword}
                      />
                    </Grid>
                  </Grid>
                </ResponsiveCardContent>

                <ResponsiveCardActions>
                  <Grid container justify='flex-end'>
                    <Button
                      className='orangeLink'
                      variant='text'
                      disabled={isSubmitting}
                      onClick={onCancel}
                      data-cy='cancel'
                    >
                      CANCEL
                    </Button>

                    <Button
                      color='primary'
                      variant='text'
                      disabled={isSubmitting}
                      type='submit'
                      data-cy='resetPassword'
                    >
                      RESET PASSWORD
                    </Button>
                  </Grid>
                </ResponsiveCardActions>
              </form>
            );
          }}
        </Formik>
      </ResponsiveCard>
    </CenterAlign>
  );
};

export default ResetPassword;
